export default "__VITE_ASSET__BQvFTWxr__"